"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.quoteCalculatorSettings = exports.getCalculateQuoteSettings = void 0;
var isRecurringPaymentEnabled_1 = require("@CommonFrontendBackend/QwilrPay/Utils/isRecurringPaymentEnabled");
var getCalculateQuoteSettings = function (paymentSettings) {
    return __assign({}, ((0, isRecurringPaymentEnabled_1.isRecurringPaymentEnabled)(paymentSettings) && {
        includeRecurringInDueToday: true,
    }));
};
exports.getCalculateQuoteSettings = getCalculateQuoteSettings;
var quoteCalculatorSettings = function (paymentSettingsProvider) {
    return function () { return (0, exports.getCalculateQuoteSettings)(paymentSettingsProvider === null || paymentSettingsProvider === void 0 ? void 0 : paymentSettingsProvider.paymentSettings); };
};
exports.quoteCalculatorSettings = quoteCalculatorSettings;
